module.exports = __webpack_public_path__ + "static/media/petal1.20125fd1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/spinners/petal1.svg
// module id = 1488
// module chunks = 44